import { useMemo } from "react";
import PropTypes from "prop-types";
import { getScoreColor } from "../utils/colorScales";

export default function ScoreRing({ score, size = 120, strokeWidth = 8, label, sublabel }) {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  const { color, bgColor, glowColor } = useMemo(() => getScoreColor(score), [score]);

  const offset = circumference - (score / 100) * circumference;

  return (
    <div className="flex flex-col items-center">
      <div className="relative" style={{ width: size, height: size }}>
        <svg
          width={size}
          height={size}
          className="transform -rotate-90"
          style={{ filter: `drop-shadow(0 0 10px ${glowColor})` }}
        >
          <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth={strokeWidth} />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            className="score-ring"
            style={{ "--score-offset": offset, transition: "stroke-dashoffset 1.5s ease-out" }}
          />
        </svg>
        <div
          className="absolute inset-0 flex flex-col items-center justify-center"
          style={{ backgroundColor: bgColor, borderRadius: "50%", margin: strokeWidth }}
        >
          <span className="font-display text-3xl font-bold" style={{ color }}>
            {score?.toFixed?.(0) ?? "--"}
          </span>
          <span className="text-xs text-navy-400 mt-1">/ 100</span>
        </div>
      </div>
      {label && (
        <div className="mt-3 text-center">
          <p className="font-medium text-white">{label}</p>
          {sublabel && <p className="text-xs text-navy-400 mt-0.5">{sublabel}</p>}
        </div>
      )}
    </div>
  );
}

ScoreRing.propTypes = {
  score: PropTypes.number,
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
  label: PropTypes.string,
  sublabel: PropTypes.string,
};
